<template lang="pug">
.comparison
  .btn(v-if="!isSVip" @click="goBuy") 立即开通
  .btn(v-if="isSVip" @click="goBuy") 立即续费
</template>

<script>
import request from '@/service/login/index';
import vip from '@/service/vip';

export default {
  name: 'Comparison',
  data() {
    return {
      isLogin: false,
      isSVip: false,
    };
  },
  mounted() {
    this.getAccountInfo();
  },
  methods: {
    goBuy() {
      this.$emit('goBuy');
    },
    getAccountInfo() {
      request.getAccountInfos().then((res) => {
        if (res.code === 0) {
          this.isLogin = true;
          this.yduserid = res.data.yduserid;
          this.getVipStatus();
        } else {
          this.isLogin = false;
        }
      });
    },
    getVipStatus() {
      const param = {
        imei: '1',
        keyfrom: 'webdict',
        apiversion: '1.0',
        product: '',
      };
      vip.getVipStatus(param).then((res) => {
        this.isSVip = res.svip;
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.comparison
  margin 0 auto
  width 1320px
  height 2298px
  position relative
  top -6px
  background-image url("~@/assets/imgs/privilege/bg.svg")
  background-size 100% 100%
  image-rendering -webkit-optimize-contrast
  .btn
    background-color #593712
    width 140px
    height 42px
    border-radius 100px
    position absolute
    left 0
    right 0
    margin auto
    top 108px
    text-align center
    line-height 42px
    color #FFEFE0
    font-weight 600
    font-size 14px
    cursor pointer
</style>
>
